import { Alert } from "reactstrap";

export default function NotEnoughPermissions({ container }) {
  return (
    <Alert color="danger">
      <p>{container.localeManager.strings.notEnoughPermissions}</p>
    </Alert>
  );
}
